import React from "react";
import { Link, useLocation } from "react-router-dom";

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(previousProps) {
    if (
      this.state.hasError &&
      previousProps.resetKey !== this.props.resetKey
    ) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="status-page" role="alert">
          <p className="eyebrow">Something went wrong</p>
          <h1>Our pantry needs a quick reset.</h1>
          <p>Please refresh this page, or return to the shop and try again.</p>
          <Link className="button button--primary" to="/shop">
            Return to the shop
          </Link>
        </main>
      );
    }

    return this.props.children;
  }
}

function ErrorBoundary({ children }) {
  const location = useLocation();
  const resetKey = `${location.pathname}${location.search}${location.hash}`;

  return (
    <RouteErrorBoundary resetKey={resetKey}>{children}</RouteErrorBoundary>
  );
}

export default ErrorBoundary;
